import * as React from 'react'
import { TableBody, TableRow, TableCell, Table } from '@material-ui/core'
import ReactHtmlParser from 'react-html-parser'
import { compose } from 'redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import { getPublicProduct } from 'src/core/redux/action/publicProductsAction'
import { PublicProductProfileMap, PublicProductStatusMap } from 'src/type/public-product'


interface IProps extends 
RouteComponentProps<any>,
ReturnType<typeof state2props>,
ReturnType<typeof dispatch2props> { 
}

const NewsContent = (message: any) => (ReactHtmlParser(message))

class PublicProductDetail extends React.Component<IProps, {}> {

    componentDidMount(){
        this.props.fetch()
    }

    render() {
        const {product} = this.props
        return (
            <>
                {product &&
                <>
                    <HelmetMeta title={product.name}/>
                    <section className="section__landing" style={
                        {backgroundImage: `url(${product.image_cover_url ? product.image_cover_url : "/assets/images/site/photo/box.jpg"})`}}>
                        <div className="section__content landing__text middle">
                            <h1 className="landing__title f-poppins">{product.name}</h1>
                        </div>
                    </section>
                    <section className="bg-white fullWidth">
                        <div className="section__content">
                            <div className="row">
                                <div className="col-md-push-8 col-md-4">
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell className="f-poppins">Code ISIN</TableCell>
                                                <TableCell className="f-poppins">{product.code_isin}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell className="f-poppins">Statut</TableCell>
                                                <TableCell className="f-poppins">{PublicProductStatusMap[product.status]}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell className="f-poppins">Profil</TableCell>
                                                <TableCell className="f-poppins">{PublicProductProfileMap[product.profile]}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </div>
                                <div className="col-md-pull-4 col-md-8">
                                    <div className="news-content f-poppins">{NewsContent(product.description)}</div>
                                    {product.documents && product.documents.length > 0 &&
                                        <div className="text-center mg-t-1r" >
                                            <a className="btn-outline nomargin pd-b-5 pd-t-5 pd-l-100 pd-r-100 f-poppins" href={product.documents[0].permalink}>
                                                Télécharger la brochure
                                            </a>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                </>
                }
            </>
        )
    }
}

const dispatch2props = (dispatch: any, ownProps: any) => ({
    fetch: () => dispatch(getPublicProduct(ownProps.match.params.productId)),
})
const state2props = (state: RootState) => ({
    product: state.publicProduct.entity,
})

export default compose(
    withRouter,
    connect(state2props, dispatch2props)
)(PublicProductDetail)


// WEBPACK FOOTER //
// ./src/page/PublicProduct/PublicProductDetail.tsx